import { render, staticRenderFns } from "./Theory.vue?vue&type=template&id=3806944b&scoped=true&"
import script from "./Theory.vue?vue&type=script&lang=js&"
export * from "./Theory.vue?vue&type=script&lang=js&"
import style0 from "./Theory.vue?vue&type=style&index=0&id=3806944b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806944b",
  null
  
)

export default component.exports